import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaBars, FaTimes, FaChevronRight } from 'react-icons/fa';
import Turnstile from 'react-turnstile';
import axios from 'axios';
import { filterText, trackEvent } from '../helpers/comman';

const Hero = () => {
    const [email, setEmail] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [particles, setParticles] = useState([]);
    const [token, setToken] = useState(null);

    // Initialize particles
    useEffect(() => {
        const particleCount = window.innerWidth < 768 ? 80 : 150;
        const newParticles = Array.from({ length: particleCount }).map(() => ({
            id: Math.random().toString(36).substring(2, 9),
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: Math.random() * 0.8 + 0.2,
            opacity: Math.random() * 0.6 + 0.1,
            speed: Math.random() * 0.3 + 0.05,
            orbitRadius: Math.random() * 50 + 10,
            angle: Math.random() * 360,
        }));
        setParticles(newParticles);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        trackEvent('btn_get_started_click')
        if (!token) {
            alert("Please solve the captcha first!!");
            return;
        }
        setIsSubmitted(true); 

        axios.post(
            'https://lmonk.pytr.in/api/subscribers',
            {
                email: email,
                name: 'The Subscriber',
                status: 'enabled',
                list_uuids: [process.env.REACT_APP_LIST_MONK_ID],
                cf_token: token,
            },
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Authorization': 'Basic bGlzdG1vbms6aW5CZXpWbXJub0V6bQ==',
                    'Content-Type': 'application/json',
                    // 'X-cloudflare': token
                }
            }
        )
        .then((res) => {
            const msg = res?.data?.message || "Thank you for subscribing!";
            alert(msg);
            setEmail("");
            setToken(null)
        })
        .catch((err) => {
            const msg = err?.response?.data?.message || err?.message || "Subscription failed. Please try again.";
            alert(msg);
            console.error(err);
        });
    };

    const navItems = [
        { name: 'Features', href: '#features' },
    ];

    return (
        <section className="min-h-screen flex flex-col relative overflow-hidden bg-black">
            {/* Cosmic Background Elements */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                {/* Deep Space Gradient */}
                <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/20 to-black" />

                {/* Stars and Particles */}
                {particles.map((particle) => (
                    <motion.div
                        key={particle.id}
                        className="absolute rounded-full bg-cyan-300"
                        style={{
                            width: `${particle.size}px`,
                            height: `${particle.size}px`,
                            left: `calc(50% + ${Math.cos(particle.angle * (Math.PI / 180)) * particle.orbitRadius}vw)`,
                            top: `calc(50% + ${Math.sin(particle.angle * (Math.PI / 180)) * particle.orbitRadius}vh)`,
                            opacity: particle.opacity,
                        }}
                        animate={{
                            x: [0, Math.cos(particle.angle * (Math.PI / 180)) * 15],
                            y: [0, Math.sin(particle.angle * (Math.PI / 180)) * 15],
                            transition: {
                                duration: 15 / particle.speed,
                                repeat: Infinity,
                                repeatType: "reverse",
                                ease: "linear"
                            }
                        }}
                    />
                ))}

                {/* Central Solar Glow */}
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full bg-radial-gradient(circle_at_center, rgba(255,109,0,0.15) 0%, transparent 70%) blur-xl" />

                {/* Subtle Grid */}
                <div className="absolute inset-0 opacity-10 bg-[size:100px_100px] bg-[linear-gradient(to_right,rgba(255,109,0,0.1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,109,0,0.1)_1px,transparent_1px)]" />
            </div>

            {/* Orbital Rings */}
            <motion.div
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] max-w-[800px] max-h-[800px] border border-blue-500/10 rounded-full z-0"
                animate={{ rotate: 360 }}
                transition={{ duration: 120, repeat: Infinity, ease: "linear" }}
            >
                <div className="absolute top-1/2 left-0 w-3 h-3 rounded-full bg-blue-400 transform -translate-y-1/2 -translate-x-1/2 shadow-[0_0_8px_rgba(255,109,0,0.8)]" />
            </motion.div>

            <motion.div
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[60vw] h-[60vw] max-w-[600px] max-h-[600px] border border-blue-500/15 rounded-full z-0"
                animate={{ rotate: -360 }}
                transition={{ duration: 90, repeat: Infinity, ease: "linear" }}
            >
                <div className="absolute top-0 left-1/2 w-2 h-2 rounded-full bg-cyan-300/80 transform -translate-x-1/2 -translate-y-1/2 shadow-[0_0_6px_rgba(255,109,0,0.6)]" />
            </motion.div>

            {/* Sticky Navigation Bar */}
            <header className={`fixed top-0 left-0 right-0 py-4 px-6 sm:px-12 flex items-center justify-between z-50 
  transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]
  ${scrolled ? 'bg-black/50 backdrop-blur-md' : 'bg-transparent backdrop-blur-none'}
  border-b ${scrolled ? 'border-orange-900/30' : 'border-transparent'}
  will-change-[background,backdrop-filter]`}>
                <a href="/" onClick={() => {trackEvent("btn_nav_logo_clicked")}} className="text-2xl font-bold text-blue-400 z-50 hover:text-cyan-300 transition-colors">
                    NIVRITTI
                </a>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex items-center space-x-8">
                    {navItems.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className="text-cyan-300/80 hover:text-blue-400 transition-colors text-lg relative group"
                        >
                            {item.name}
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 transition-all duration-300 group-hover:w-full"></span>
                        </a>
                    ))}
                    <a
                        href="#try"
                        className="px-6 py-3 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 text-black font-medium hover:from-blue-400 hover:to-blue-500 transition-all text-lg relative overflow-hidden"
                    >
                        <span className="relative z-10">Try Now</span>
                        <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 opacity-0 hover:opacity-100 transition-opacity duration-300"></span>
                    </a>
                </nav>

                {/* Mobile Menu Button */}
                <button
                    className="md:hidden text-blue-400 z-50 focus:outline-none p-2 rounded-lg hover:bg-blue-500/10 transition-colors"
                    onClick={() => { setMobileMenuOpen(!mobileMenuOpen); trackEvent("btn_phone_menu") }}
                    aria-label="Toggle menu"
                >
                    {mobileMenuOpen ? (
                        <FaTimes size={24} />
                    ) : (
                        <FaBars size={24} />
                    )}
                </button>
            </header>

            {/* Mobile Menu Overlay */}
            <AnimatePresence>
                {mobileMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black/95 backdrop-blur-lg z-40 pt-20 px-6 md:hidden"
                    >
                        <motion.div
                            initial={{ y: -20 }}
                            animate={{ y: 0 }}
                            exit={{ y: -20 }}
                            className="flex flex-col space-y-6"
                        >
                            {navItems.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    className="text-cyan-300 text-2xl py-4 flex items-center justify-between border-b border-orange-900/30"
                                    onClick={() => {setMobileMenuOpen(false); trackEvent("btn_header_btn_" + filterText(item.name))}}
                                >
                                    {item.name}
                                    <FaChevronRight className="text-blue-400/60" />
                                </a>
                            ))}
                            <a
                                href="#try"
                                className="mt-8 px-6 py-4 rounded-xl bg-blue-500 text-black font-medium text-center text-lg"
                                onClick={() => { setMobileMenuOpen(false); trackEvent("btn_try_now") }}
                            >
                                Try Now
                            </a>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Main Content */}
            <div className="flex-1 flex flex-col items-center justify-center relative z-20 px-6 sm:px-8 pt-20 pb-32">
                <motion.div
                    className="text-center max-w-5xl mx-auto w-full"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    {/* Logo */}
                    <div className="mb-6 flex justify-center w-full">
                        <svg
                            viewBox="100 300 334 200"
                            className="w-full max-w-[700px] h-[180px] md:h-[220px] fill-blue-400"
                            preserveAspectRatio="xMidYMid meet"
                        >
                            {/* logo paths with better viewBox */}
                            <rect x="440.04" y="363.04" width="9.39" height="68.61" />
                            <rect x="304.26" y="363.04" width="9.39" height="68.61" />
                            <polygon points="293.82,431.65 284.42,431.65 268.42,404.04 277.82,404.04 " />
                            <rect x="247.39" y="363.04" width="9.39" height="68.61" />
                            <polygon points="213,431.65 203.61,431.65 180.61,363.04 190,363.04 " />
                            <polygon points="206.13,431.65 215.52,431.65 238.52,363.04 229.13,363.04 " />
                            <rect x="343" y="363.71" width="9.39" height="67.94" />
                            <rect x="343.25" y="341.4" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 715.1821 19.7908)" width="8.89" height="52.17" />
                            <rect x="401.09" y="364.61" width="9.39" height="67.04" />
                            <rect x="401.34" y="341.4" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 773.269 -38.2962)" width="8.89" height="52.17" />
                            <rect x="160.43" y="363.04" width="9.39" height="68.61" />
                            <rect x="85.3" y="363.04" width="9.51" height="68.61" />
                            <rect x="139.71" y="363.04" width="9.57" height="68.61" />
                            <path d="M271.83,363.04h-24.44v42.1h24.44c5.81,0,11.08-2.36,14.89-6.16c3.8-3.81,6.16-9.08,6.16-14.89
                C292.88,372.47,283.46,363.04,271.83,363.04z M280.21,393.03c-2.28,2.29-5.44,3.7-8.93,3.7h-14.5v-25.27h14.5
                c6.98,0,12.63,5.65,12.63,12.63C283.91,387.58,282.5,390.74,280.21,393.03z"/>
                            <path d="M94.7,371.1c1.16,0,2.32,0,3.48,0c0.93,0,1.83,0,2.73,0.29c1.82,0.6,3.04,2.03,3.94,3.66
                c1.12,2.02,2.43,3.93,3.65,5.89c1.09,1.77,2.19,3.53,3.28,5.3c1.31,2.11,2.62,4.23,3.93,6.34c1.44,2.32,2.88,4.64,4.31,6.97
                c1.48,2.39,2.96,4.79,4.45,7.18c1.44,2.33,2.88,4.66,4.32,6.98c1.32,2.12,2.63,4.25,3.95,6.37c1.1,1.78,2.21,3.57,3.31,5.35
                c0.81,1.31,1.62,2.61,2.43,3.92c0.43,0.69,0.86,1.38,1.28,2.07c0.05,0.07,0.09,0.15,0.14,0.22c0,0,0-16.78,0-16.78
                c-0.62-1.02-1.25-2.05-1.87-3.07c-1.58-2.59-3.16-5.18-4.74-7.77c-2.1-3.44-4.19-6.88-6.29-10.32c-2.18-3.57-4.35-7.13-6.53-10.7
                c-1.82-2.98-3.63-5.95-5.45-8.93c-1.02-1.67-2.03-3.33-3.05-5c-1.55-2.55-3.91-4.79-6.82-5.66c-2.69-0.8-5.82-0.37-8.6-0.37
                c-0.62,0-1.23,0-1.85,0C94.7,363.04,94.7,371.1,94.7,371.1z"/>
                        </svg>
                    </div>

                    {/* Main Headline */}
                    <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-7xl font-bold tracking-tight text-white mb-8">
                        Your <span className="text-blue-400">AI</span> Commerce Assistant That Sells, Supports & Scales
                    </h1>

                    {/* Subheadline */}
                    <p className="text-xl md:text-2xl text-cyan-300/80 mb-12 max-w-3xl mx-auto"  id='try'>
                        From product discovery to checkout, Nivritti engages customers, resolves issues, and boosts conversions-autonomously.
                    </p>

                    {/* Email Capture */}
                    {/* Email Capture */}
                    <motion.div
                        className="max-w-2xl mx-auto"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <div className="text-center mb-4" >
                            <p className="text-blue-400/80 text-lg font-medium">Get early access</p>
                        </div>
                        <form onSubmit={handleSubmit} className="w-full">
                            <div className="flex flex-row gap-2 sm:gap-4">
                                <div className="flex-1 relative min-w-0"> {/* Ensures input doesn't overflow */}
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Enter your email"
                                        required
                                        className="w-full py-3 sm:py-4 px-4 sm:px-6 text-white bg-black/30 backdrop-blur-sm border border-blue-500/30 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-cyan-300/50 text-base sm:text-lg"
                                    />
                                    
                                    
                                </div>
                                
                                <button
                                    type="submit"
                                    className="relative whitespace-nowrap py-3 sm:py-4 px-4 sm:px-6 text-base sm:text-lg font-medium rounded-xl bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-400 hover:to-blue-500 text-white transition-all duration-300 shadow-lg hover:shadow-blue-500/30"
                                >
                                    <span className="relative z-10">Get Started</span>
                                    <div className="absolute inset-0 rounded-xl overflow-hidden">
                                        <div className="absolute inset-0 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.1)_50%,transparent_75%)] bg-[length:250%_250%,100%_100%] bg-[position:100%_100%,0_0] bg-no-repeat opacity-0 hover:opacity-100 hover:bg-[position:0_0,0_0] hover:duration-[1.5s] transition-all" />
                                    </div>
                                </button>
                            </div>
                             <span class=" text-white text-xs relative right-20 ">*By subscribing, you agree to receive our marketing and promotional emails.</span>
                            <Turnstile 
                            className='mt-4'
                                sitekey={process.env.REACT_APP_CLOUDFLARE_TURSTILE_KEY}
                                onVerify={(token) => setToken(token)}
                                onClick={() => trackEvent("btn_turnstile_clicked")}
                            />
                            {isSubmitted && (
                                <div className="text-cyan-300 text-sm mt-4 animate-fadeIn">
                                    Thank you! We'll be in touch soon.
                                </div>
                            )}
                        </form>
                    </motion.div>

                    {/* Trust Indicators */}
                    <div className="mt-16 flex flex-col items-center">
                        <p className="text-cyan-300/60 text-sm mb-6">Build Custom Experiences For :</p>
                        <div className="flex flex-wrap justify-center gap-8 opacity-8" >
                            {[ 'Ecommerce',  'Travel' , 'Hospitality',  'Lending',   'Banking',  'Gaming',].map((company, i) => (
                                <div key={i} className="px-6 py-2 hover:text-blue-400  text-lg rounded-full bg-white text-black font-medium ">
                                    {company}
                                </div>
                            ))}
                            <span className="text-white text-sm mt-2">&  many more....</span>
                        </div>
                    </div>
                </motion.div>
            </div>

            {/* Floating Elements */}
            <motion.div
                className="absolute bottom-1/4 left-1/3 w-4 h-4 rounded-full bg-blue-400/80 blur-sm z-10"
                animate={{
                    y: [0, -20, 0],
                    opacity: [0.8, 1, 0.8],
                }}
                transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
            <motion.div
                className="absolute top-1/3 right-1/4 w-3 h-3 rounded-full bg-cyan-300/60 blur-sm z-10"
                animate={{
                    y: [0, -15, 0],
                    opacity: [0.6, 0.9, 0.6],
                }}
                transition={{
                    duration: 5,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
            />
        </section>
    );
};

export default Hero;